/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Theme_LightInputs */

const en_settings_theme_light = /** @type {(inputs: Settings_Theme_LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Light`)
};

const he_settings_theme_light = /** @type {(inputs: Settings_Theme_LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`בהיר`)
};

/**
* | output |
* | --- |
* | "Light" |
*
* @param {Settings_Theme_LightInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const settings_theme_light = /** @type {((inputs?: Settings_Theme_LightInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Theme_LightInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_theme_light(inputs)
	return he_settings_theme_light(inputs)
});